import React from 'react';
import clsx from 'clsx';
import {
  ToDoStatus,
} from 'types/toDo';
import Select from 'core/components/Select';

type Props = {
  onChange: (...event: any[]) => void;
  value: ToDoStatus | undefined;
  options?: ToDoStatus[];
  disabled?: boolean;
  className?: string;
  selectClassName?: string;
  muiSelectClassName?: string;
  id?: string;
  isLoading?: boolean;
  loadingText?: string;
};

export const statusColorClasses: Record<string, string> = Object.freeze({
  NotStarted: '!bg-sky-200',
  Completed: '!bg-emerald-300',
  InProgress: '!bg-violet-200',
  Abandon: '!bg-gray-200',
  Abandoned: '!bg-gray-200',
});

export default function StatusSelect(props: Props) {
  const {
    id,
    onChange,
    value,
    options,
    disabled,
    className,
    isLoading,
    selectClassName,
    muiSelectClassName,
    loadingText = 'Loading...',
  } = props;
  return (
    <div
      className={className}
      role="button"
      tabIndex={-1}
      onClick={(event) => { event.stopPropagation(); }}
      onKeyDown={() => {}}
    >
      <Select<ToDoStatus>
        id={id}
        selectClassName={clsx('[&:not(:focus-within)]:!border-white focus-within:!border-black !border-1 !pointer-events-auto', selectClassName)}
        disabled={disabled}
        value={value}
        options={options ?? []}
        getLabel={(option: ToDoStatus) => option.statusDisplayName}
        getValue={(option: ToDoStatus) => option.transitionName}
        onChange={onChange}
        muiClasses={{
          select: clsx(
            muiSelectClassName,
            statusColorClasses[value?.transitionName ?? ''],
            { '!bg-gray-100 !cursor-wait': isLoading },
          ),
        }}
        renderValue={() => (
          isLoading ? loadingText : value?.statusDisplayName
        )}
      />
    </div>
  );
}
